import { ArrowRight } from 'lucide-react';

interface OfferType {
  id: string;
  eyebrow: string;
  title: string;
  rows: { label: string; value: string }[];
}

const OFFER: OfferType[] = [
  {
    id: 'eengezinswoningen',
    eyebrow: 'Voor de nestbouwers',
    title: '3 eengezinswoningen',
    rows: [
      { label: 'Oppervlakte', value: 'Vanaf 140 m²' },
      { label: 'Slaapkamers', value: '2 – 4' },
      { label: 'Buitenruimte', value: 'Royale buitenruimte' },
      { label: 'EPC', value: 'Gunstig' },
      { label: 'Prijs', value: 'Op aanvraag' },
    ],
  },
  {
    id: 'appartementen',
    eyebrow: 'Voor de levensgenieters',
    title: '5 appartementen',
    rows: [
      { label: 'Oppervlakte', value: 'Vanaf 102 m²' },
      { label: 'Slaapkamers', value: '2 – 4' },
      { label: 'Buitenruimte', value: 'Ruime terrassen' },
      { label: 'EPC', value: 'Gunstig' },
      { label: 'Prijs', value: 'Op aanvraag' },
    ],
  },
];

export default function OfferSummary() {
  return (
    <section id="aanbod" className="py-24 bg-surface-alt">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="mb-14 max-w-2xl">
          <span className="text-xs tracking-[0.3em] uppercase text-primary font-semibold mb-4 block">Aanbod</span>
          <h2 className="font-serif text-4xl md:text-5xl tracking-wide mb-6">Het aanbod: 3 eengezinswoningen en 5 appartementen</h2>
          <p className="text-secondary font-normal md:font-light leading-relaxed">
            Acht nieuwbouwwoningen tussen de Leopoldstraat en de Floris Primsstraat in Grobbendonk.
          </p>
          <span className="inline-block mt-4 text-xs font-semibold tracking-wide uppercase text-primary bg-primary/10 px-4 py-2">
            Aankoop onder 6% btw mogelijk*
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {OFFER.map((type) => (
            <article key={type.id} className="bg-white p-8 md:p-10 border-l-4 border-primary shadow-sm flex flex-col">
              <p className="text-xs tracking-[0.2em] uppercase text-secondary mb-3">{type.eyebrow}</p>
              <h3 className="font-serif text-2xl sm:text-3xl md:text-2xl lg:text-3xl xl:text-4xl tracking-wide mb-6">{type.title}</h3>
              <dl className="divide-y divide-secondary/20 mb-10">
                {type.rows.map((row) => (
                  <div key={row.label} className="flex items-baseline justify-between gap-6 py-4">
                    <dt className="text-secondary">{row.label}</dt>
                    <dd className="font-medium text-right">{row.value}</dd>
                  </div>
                ))}
              </dl>
              <a
                href="#contact"
                className="mt-auto bg-primary text-white px-8 py-4 text-sm tracking-widest uppercase hover:bg-text-main transition-all flex items-center gap-3 w-fit"
              >
                Vraag prijzen aan <ArrowRight size={16} />
              </a>
            </article>
          ))}
        </div>

        <p className="mt-8 text-xs text-secondary">
          Oppervlaktes en kenmerken zijn indicatief. * Het verlaagd btw-tarief van 6% is onder voorwaarden mogelijk. Lees de <a href="/disclaimer" className="underline hover:text-primary">disclaimer</a> of neem contact op voor meer info.
        </p>
      </div>
    </section>
  );
}
